<template>
  <img
    class="h-7 w-auto"
    src="/img/logos/360ai/full-dark.svg"
    alt="360AI Logo"
  />
</template>
